<template>
  <div>
    <px-lista-links class="mb-4" :links="links" :loading="loading"/>
  </div>
</template>

<script>
import AprovacaoService from '@/modules/aprovacao/aprovacao-service';

export default {
  props: {
    aprovacao: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      loading: false,
      links: [],
    };
  },
  methods: {
    getLinks() {
      this.loading = true;
      AprovacaoService.getLinks(this.aprovacao.id)
        .then(({ data }) => {
          this.links = data;
        })
        .finally(() => {
          this.loading = false;
        });
    },
  },
  created() {
    this.getLinks();
  },
};
</script>
